// src/index.ts

import { TalkingHeadAvatar } from './components/TalkingHeadAvatar';

export type {
  AvatarConfig,
  TalkingHeadAvatarProps,
  AvatarActions,
  SpeechOptions
} from './types';

export { TalkingHeadAvatar };
export default TalkingHeadAvatar;
